"use client";

import { Select } from "@/components/ui/Select";
import { Text } from "@/components/ui/Text";
import { startTransition, useRef } from "react";

import { useTranslations } from "@/i18n/client";
import { LANGUAGES, useGeo } from "@/i18n/routing";
import type { RouteGeoData } from "@frend-digital/centra/middleware";
import type { GeoLocale } from "@frend-digital/next/i18n";
import styles from "./index.module.css";

export const LanguageSelect = ({ userdata }: { userdata: RouteGeoData | null }) => {
	const { action, language: locale, country } = useGeo();
	const t = useTranslations("i18n.language");

	const contentRef = useRef<HTMLDivElement>(null!);

	const handleLanguageChange = (language: string) => {
		startTransition(() => {
			action(`${language}-${country}` as GeoLocale);
		});
	};

	return (
		<div className={styles.content} ref={contentRef}>
			<Text variant="h4" bold>
				{t("header")}
			</Text>
			<Text variant="body2">{t("subHeader")}</Text>
			<Select
				onValueChange={(value) => {
					if (value === locale) return;
					handleLanguageChange(value);
				}}
				large
				hideReset
				renderValue={(value) => (
					<Text variant="utility5" color="primary">
						{t(value)}
					</Text>
				)}
				placeholder={t("placeholder")}
				name={"language"}
				defaultValue={locale}
				items={LANGUAGES.map((l) => ({
					name: t(l),
					value: l,
				}))}
			/>
		</div>
	);
};
